<template>
  <div style="position: relative;">
      <Breadcrumbnav 
          :breadcrumb="breadcrumb"
          :showBread="true"/>
      <div class="documentos_tudo mainmenu" v-if="showMenu">
          <div class="wrap2">
              <div class="row servico_header">
                  <div class="small-12 medium-7 large-8 columns servico_title logobackground"
                      :style="backgroundStyle">
                      <h1>{{ title }}</h1>
                  </div>
                  <div class="small-12 medium-5 large-4 columns servico_menu">
                      <div class="row" v-for="section in Object.values(sectionsToShow)" :key="section.path">
                          <RouterLink :to="section.path" active-class="active">
                              {{ section.title }}
                          </RouterLink>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <div class="documentos_tudo">
        <div class="wrap2">
          <slot></slot>
        </div>
      </div>
  </div>
</template>
  
<script>
import { ref, computed, watch, provide } from 'vue';
import { i18n } from '@/main.js';
import { useRoute, RouterLink } from 'vue-router';
import Breadcrumbnav from '@/components/breadcrumbnav.vue';

export default {
    components: {
        Breadcrumbnav
    },
    setup(props) {

        const { t } = i18n.global; 

        const sections = ref({
            apresentacao: { path: '/apresentacao', title: t('menu.apresentacao') },
            noticias: { path: '/noticias', title: t('menu.noticias') },
            calendarios: { path: '/calendarios', title: t('menu.calendarios') },
            candidaturas: { path: '/inscricoes', title: t('menu.provas') },
            cursos: { path: '/cursos', title: t('menu.cursos') },
            provas: { path: '/provas', title: t('menu.paccs') },
            resultados: { path: '/resultados', title: t('menu.resultados') },
            documentacao: { path: '/documentacao', title: t('menu.documentacao') },
            faq: { path: '/faq', title: t('menu.faq') },
            provasid: {path: '/provas', title: 'PACCS - Programa e Enunciados'}
        });

        const sectionsToShow = ref({
            apresentacao: { path: '/apresentacao', title: t('menu.apresentacao') },
            noticias: { path: '/noticias', title: t('menu.noticias') },
            calendarios: { path: '/calendarios', title: t('menu.calendarios') },
            candidaturas: { path: '/inscricoes', title: t('menu.provas') },
            cursos: { path: '/cursos', title: t('menu.cursos') },
            provas: { path: '/provas', title: t('menu.paccs') },
            resultados: { path: '/resultados', title: t('menu.resultados') },
            documentacao: { path: '/documentacao', title: t('menu.documentacao') },
            faq: { path: '/faq', title: t('menu.faq') },
        });


        const showMenu = ref(true);

        const route = useRoute();

        const breadcrumb = ref([
          { ID: 1, text: "Homepage", href: "https://www.uma.pt", isRoute: false },
          { ID: 2, text: "Admissão",  href: "https://www.uma.pt/admissao", isRoute: false },
          { ID: 3, text: "Maiores de 23",  href: "https://www.uma.pt/admissao/maiores-23", isRoute: false },
          { ID: 4, text: "Apresentação",  path: "/apresentacao", isRoute: true }
        ]) 

        const currentProva = ref(null)
        const updateCurrentProva = (p) => {
            currentProva.value = p;
            breadcrumb.value[4] = {
              ID: 4,
              text: currentProva.value.pacc_nome,
              isRoute: true
            }
        }
        
        provide('provas', {
            currentProva,
            updateCurrentProva
        })

        watch(route, (to, from) => {
          if(to.name != undefined){
            showMenu.value = to.name !== "provas-id";
            const key = to.name.replace("-","");
            const { title, path } = sections.value[key]; 
            breadcrumb.value[3] = {
                ID: 4,
                text: title,
                path: path,
                isRoute: true
            }
          }
          if(route.name != "provas-id" && breadcrumb.value.length > 4){
            breadcrumb.value.pop();
          }
        }, { deep: true, immediate: true });

        const backgroundStyle = computed(() => {
            return {
              backgroundImage: `url('https://www.uma.pt/wp-content/themes/uma/images/Logo23_3.png')`,
            };
        });

        const title = "Maiores de 23"

        return {
          breadcrumb,
          sections,
          backgroundStyle,
          showMenu,
          title,
          sectionsToShow
        };
    },
};
</script>
  
<style scoped>
/*#region Layout*/
#servicosapp{
    opacity: 0;
}
#servicosapp.show{
    opacity: 1;
}

.wrap {
    padding-left: 10%;
    padding-right: 10%;
    max-width: 100%;
    margin: 0;
}

.wrap2 {
    padding-right: 10%;
    padding-left: 10%;
}

.documentos_tudo {
    max-width: 100rem;
    padding-right: 0px;
    padding-left: 0px;
    padding-top: 15px;
    margin: 0 auto 50px;
}

.documentos_tudo.mainmenu{
    margin-bottom: 0;
}

.documentos_tudo.content{
    padding-top: 0;
}

@media (min-width: 1400px){
    .wrap {
        padding-left: 15%;
        padding-right: 15%;
        max-width: 100%;
        margin: 0;
    }
    .wrap2 {
        padding-left: 15%;
        padding-right: 15%;
        max-width: 100%;
        margin: 0;
    }
}

@media (max-width: 767px){
    .wrap {
        padding-left: 5%;
        padding-right: 5%;
    }
    .navwrapper {
        display: none;
    }
    .wrap2 {
        padding-right: 5%;
        padding-left: 5%;
    }
    .documentos_tudo{
        padding-top: 0;
    }
}

/*#endregion*/

/*#region Menu*/
.logobackground {
    background-size: 426px 380px;
    background-repeat: no-repeat;
    background-color: white;
    background-position: center;
    background-position-y: top;
}
.logobackground h1{
    display: none;
}

.row.servico_header .row {
    margin-left: 0;
    margin-right: 0;
}

.geral_data .row {
    margin-right: 0px;
    margin-left: 0px;
}

.servico_header {
    height: 500px;
    margin-top: 50px;
    padding-top: 5px;
    padding-bottom: 55px;
}

.servico_title {
    background-color: #489ad4;
}

.servico_title h1 {
    font-family: "Montserrat Bold";
    color: white;
    padding-top: 40px;
    padding-right: 175px;
    padding-left: 40px;
}

.servico_menu {
    padding-left: 0;
    padding-right: 0;
    padding-top: 55px;
    background-color: #a7d1e6;
}

.servico_menu .row:hover {
    background-color: #79b2dc;
}

.servico_menu .row:first-child {
    border-top: 1px solid #79b2dc;
}

.servico_menu .row {
    border-bottom: 1px solid #79b2dc;
    padding-left: 0px;
    padding-right: 0px;
}

.servico_menu a, .servico_menu span {
    font-family: "Montserrat SemiBold";
    color: white;
    padding-top: 6px;
    padding-bottom: 6px;
    padding-left: 20px;
    width: 100%;
}

.servico_menu .row.active, .servico_menu .row .active {
    background-color: #489ad4;
}

@media (min-width: 768px) and (max-width: 1024px){
    .servico_title h1 {
        font-size: 30px;
        padding-right: 20px;
        padding-left: 20px;
    }
}

@media (max-width: 767px){
    .logobackground {
        background-image: none !important;
    }
    .logobackground h1{
        display: flex;
    }
    .row .row {
        margin-left: 0;
    }
    .servico_header {
        height: auto;
        padding-bottom: 20px;
        padding-top: 0;
        margin-bottom: 15px;
        margin-top: 15px;
    }
    .servico_title h1 {
        padding-top: 20px;
        padding-right: 95px;
        padding-left: 10px;
        padding-bottom: 20px;
        font-size: 20px;
    }
    .servico_menu {
        margin-right: 0;
        margin-left: 0;
        padding-left: 0;
        padding-right: 0;
        padding-top: 0;
    }
    .servico_menu .row:first-child {
        border-top: 1px solid #79b2dc;
    }
    .servico_menu .row {
        margin-right: 0;
        margin-left: 0;
    }
    .servico_menu .row.active, .servico_menu .row .active {
        background-color: #79b2dc;
    }
    .servico_menu a {
        font-family: "Montserrat Semibold";
        font-size: 12px!important;
        text-transform: uppercase;
    }
    .servico_menu .row:last-child {
        border-bottom: 1px solid transparent;
    }

    .servico_header {
        margin-bottom: -10px;
    }
}



/*#endregion*/


</style>
  